import React, {lazy} from 'react'
import {Grid, Typography, withStyles} from '@material-ui/core';
import {withTranslation} from 'react-i18next';

import ChannelService from "../../lib/ChannelService";
import legal1Icon from "../../assets/img/effort/icon-legal-1-1.png";
import legal2Icon from "../../assets/img/effort/icon-legal-1-2.png";
import legal3Icon from "../../assets/img/effort/icon-legal-1-3.png";
import legalPCImg from "../../assets/img/effort/img-legal-1-l.png";
import legalMobileImg from "../../assets/img/effort/img-legal-1-s.png";
import legalImg from "../../assets/img/effort/img-legal-2.png";
import legalPCEnImg from "../../assets/img/effort/img-legal-1-l-en.png";
import legalMobileEnImg from "../../assets/img/effort/img-legal-1-s-en.png";
import legalEnImg from "../../assets/img/effort/img-legal-2-en.png";
import CustomButton from "../../components/CustomButton";
import { isMobile } from 'react-device-detect';
import {connect} from "react-redux";
import ls from "local-storage";
import {Redirect} from "react-router-dom";

const AppBar = lazy(() => import('../../components/AppBar'));
const AppFooter = lazy(() => import('../../components/AppFooter'));


const useStyles = (theme) => ({
    root: {
        overflowX: 'hidden'
    },
    darkContainer: {
        backgroundColor: '#F2F2F4',
        paddingTop: '140px',
    },
    effortTitle: {
        color: '#222222',
        fontSize: '32px',
        paddingBottom: '64px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px',
        },
    },
    lightContainer: {
        backgroundColor: '#F8F8F9',
        paddingTop: '120px',
        paddingBottom: '120px',
        textAlign: 'center',
        paddingLeft: 'calc((100% - 1200px)/2)',
        paddingRight: 'calc((100% - 1200px)/2)',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '80px',
        },
    },
    rectHeader: {
        fontSize: '32px',
        fontWeight: 'bold',
        marginBottom: '56px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            marginLeft: '10%',
            marginRight: '10%',
        },
    },
    rectTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
    },
    rectBody: {
        fontSize: '14px',
        color: '#4f4f4f',
        marginBottom: '24px'
    },
    rect: {
        width: '388px',
        height: '537px',
        padding: '48px 32px 48px',
        borderRadius: '20px',
        boxShadow: '0 1px 3px 0 rgba(27, 27, 27, 0.2)',
        backgroundColor: 'white',
        margin: '8px',
        textAlign: 'left',
        [theme.breakpoints.down('md')]: {
            height: '600px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '20%',
            marginRight: '20%',
            height: 'auto',
            width: '60%',
            padding: '32px 24px 32px',
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: '18px',
            marginRight: '18px',
            width: 'calc(100% - 36px)',
            padding: '32px 24px 32px',
        },
    },
    rectEn: {
        width: '388px',
        height: '698px',
        padding: '48px 32px 94px',
        borderRadius: '20px',
        boxShadow: '0 1px 3px 0 rgba(27, 27, 27, 0.2)',
        backgroundColor: 'white',
        margin: '8px',
        textAlign: 'left',
        [theme.breakpoints.down('md')]: {
            height: '790px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '15%',
            marginRight: '15%',
            height: 'auto',
            width: '70%',
            padding: '32px 24px 32px',
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: '18px',
            marginRight: '18px',
            width: 'calc(100% - 36px)',
            padding: '32px 24px 32px',
        },
    },
    rectContainer: {
        marginTop: '80px',
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            paddingLeft: '16px',
            paddingRight: '16px',
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            marginTop: '60px',
            alignItems: 'center',
        },
    },
    source: {
        fontSize: '12px',
        color: '#aaaaaa',
        marginTop: '20px'
    },
    chartContainer: {
        marginTop: '160px',
        paddingLeft: '60px',
        paddingRight: '60px',
        [theme.breakpoints.down('md')]: {
            marginTop: '130px',
        },
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '24px',
            paddingRight: '24px',
        },
    },
    charTitleBold: {
        fontSize: '32px',
        fontFamily: 'Noto Sans KR Bold',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
        },
    },
    chartTitleLight: {
        fontSize: '32px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
        },
    },
    chartDesc: {
        fontSize: '18px',
        color: '#4f4f4f',
        width: '600px',
        marginTop: '40px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            width: '100%',
        },
    },
    startButton: {
        width: '250px',
        marginBottom: '60px'
    },
    flowChart: {
        width: '1060px',
        height: '350px',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            height: 'auto'
        },
    },
    legalPcImg: {
        width: '1060px',
        height: '415px',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            height: 'auto'
        },
    },
    darkChartContainer: {
        textAlign: 'left',
        backgroundColor: '#F2F2F4',
        paddingTop: '120px',
        paddingLeft: 'calc((100% - 1040px)/2)',
        paddingRight: 'calc((100% - 1040px)/2)',
        paddingBottom: '40px',
        [theme.breakpoints.down('md')]: {
            paddingTop: '140px',
            paddingLeft: '60px',
            paddingRight: '60px',
        },
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '24px',
            paddingRight: '24px',
        },
    }
})

class Effort extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        ChannelService.boot({
            "pluginKey": process.env.REACT_APP_PLUGIN_KEY,
            "language": "ko",
        });
    }

    componentWillUnmount() {
        ChannelService.shutdown();
    }

    render() {
        const { classes, t, lang } = this.props;

        const isLoggedIn = ls.get('isLoggedIn');

        return (
            (!isLoggedIn ?
                <React.Fragment>
                    <div className={classes.root}>
                        <AppBar/>
                        <div className={classes.darkContainer}>
                            <Typography className={classes.effortTitle}>{t("Effort.effortTitle")}</Typography>
                        </div>
                        <div className={classes.lightContainer}>
                            <Typography
                                className={classes.rectHeader}>{t("Effort.rectHeader")}</Typography>
                            <Grid item xs={12} className={classes.rectContainer}>
                                <Grid item className={lang === 'ko' ? classes.rect : classes.rectEn}>
                                    <img src={legal1Icon} width={40} height={40}/>
                                    <Typography className={classes.rectTitle}
                                                style={{ marginTop: '16px' }}>{t("Effort.rectTitle1")}</Typography>
                                    <Typography className={classes.rectTitle}
                                                style={{ marginBottom: '32px' }}>{t("Effort.rectTitle2")}</Typography>
                                    <Typography className={classes.rectBody}>{t("Effort.rectBody1")}</Typography>
                                    <Typography className={classes.rectBody}>{t("Effort.rectBody2")}</Typography>
                                    <Typography className={classes.rectBody}>{t("Effort.rectBody3")}</Typography>
                                </Grid>
                                <Grid item className={lang === 'ko' ? classes.rect : classes.rectEn}>
                                    <img src={legal2Icon} width={40} height={40}/>
                                    <Typography className={classes.rectTitle}
                                                style={{ marginTop: '16px' }}>{t("Effort.rectTitle3")}</Typography>
                                    <Typography className={classes.rectTitle}
                                                style={{ marginBottom: '32px' }}>{t("Effort.rectTitle4")}</Typography>
                                    <Typography className={classes.rectBody}>{t("Effort.rectBody4")}</Typography>
                                    <Typography className={classes.rectBody}>{t("Effort.rectBody5")}</Typography>
                                </Grid>
                                <Grid item className={lang === 'ko' ? classes.rect : classes.rectEn}>
                                    <img src={legal3Icon} width={40} height={40}/>
                                    <Typography className={classes.rectTitle}
                                                style={{ marginTop: '16px' }}>{t("Effort.rectTitle5")}</Typography>
                                    <Typography className={classes.rectTitle}
                                                style={{ marginBottom: '32px' }}>{t("Effort.rectTitle6")}</Typography>
                                    <Typography className={classes.rectBody}>{t("Effort.rectBody6")}</Typography>
                                    <Typography className={classes.rectBody}>{t("Effort.rectBody7")}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className={classes.source}>{t("Effort.source")}</Typography>
                            </Grid>
                            <Grid container className={classes.chartContainer}>
                                {
                                    lang === 'ko' ?
                                        <React.Fragment>
                                            <Grid item xs={12} style={{ display: 'flex' }}>
                                                <Typography
                                                    className={classes.charTitleBold}>{t("Effort.charTitleBold")}</Typography>
                                                <Typography
                                                    className={classes.chartTitleLight}>{t("Effort.charTitleRight1")}</Typography>
                                            </Grid>
                                            <Grid item xs={12} style={{ textAlign: 'left' }}>
                                                <Typography
                                                    className={classes.chartTitleLight}>{t("Effort.charTitleRight2")}</Typography>
                                            </Grid>
                                        </React.Fragment> :
                                        <React.Fragment>
                                            <Grid item xs={12} style={{ textAlign: 'left', width: '470px' }}>
                                                <Typography
                                                    className={classes.chartTitleLight}>{t("Effort.charTitleRight1")}</Typography>
                                                <Typography
                                                    className={classes.charTitleBold}>{t("Effort.charTitleBold")}</Typography>
                                            </Grid>
                                        </React.Fragment>
                                }
                                <Grid item xs={12} style={{ textAlign: 'left' }}>
                                    <Typography
                                        className={classes.chartDesc}>{t("Effort.chartDesc")}</Typography>
                                </Grid>
                                <Grid item xs={12} style={{ marginTop: '64px' }}>
                                    {
                                        isMobile ?
                                            <img src={lang === 'ko' ? legalMobileImg : legalMobileEnImg}
                                                 width={'100%'}/>
                                            : <img src={lang === 'ko' ? legalPCImg : legalPCEnImg}
                                                   className={classes.legalPcImg}/>
                                    }
                                </Grid>
                            </Grid>
                            <Grid container className={classes.chartContainer} style={{ marginTop: '120px' }}>
                                {
                                    isMobile ?
                                        lang === 'ko' ?
                                            <React.Fragment>
                                                <Grid item xs={12} style={{ display: 'flex' }}>
                                                    <Typography
                                                        className={classes.charTitleBold}>{t("Effort.flowTitleMobileBold")}</Typography>
                                                    <Typography
                                                        className={classes.chartTitleLight}>{t("Effort.flowTitleMobileLight1")}</Typography>
                                                </Grid>
                                                <Grid item xs={12} style={{ textAlign: 'left' }}>
                                                    <Typography
                                                        className={classes.chartTitleLight}>{t("Effort.flowTitleMobileLight2")}</Typography>
                                                </Grid>
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <Grid item xs={12} style={{ textAlign: 'left' }}>
                                                    <Typography
                                                        className={classes.chartTitleLight}>{t("Effort.flowTitleMobileLight1")}</Typography>
                                                </Grid>
                                                <Grid item xs={12} style={{ textAlign: 'left' }}>
                                                    <Typography
                                                        className={classes.charTitleBold}>{t("Effort.flowTitleMobileBold")}</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        :
                                        lang === 'ko' ?
                                            <Grid item xs={12} style={{ display: 'flex' }}>
                                                <Typography
                                                    className={classes.charTitleBold}>{t("Effort.flowTitleBold")}</Typography>
                                                <Typography
                                                    className={classes.chartTitleLight}>{t("Effort.flowTitleLight")}</Typography>
                                            </Grid> :
                                            <Grid item xs={12} style={{ display: 'flex' }}>
                                                <Typography
                                                    className={classes.chartTitleLight}>{t("Effort.flowTitleLight")}</Typography>
                                                <Typography
                                                    className={classes.charTitleBold}
                                                    style={{ marginLeft: '10px' }}>{t("Effort.flowTitleBold")}</Typography>
                                            </Grid>

                                }
                                <Grid item xs={12} style={{ marginTop: '80px' }}>
                                    <img src={lang === 'ko' ? legalImg : legalEnImg} className={classes.flowChart}/>
                                </Grid>
                            </Grid>
                        </div>
                        <Grid container className={classes.darkChartContainer}>
                            <Grid item xs={12}>
                                <Typography
                                    className={classes.chartTitleLight}>{t("Effort.startTitleLight")}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className={classes.charTitleBold}>{t("Effort.startTitleBold")}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className={classes.chartDesc}>{t("Effort.startDesc")}</Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: '60px' }}>
                                <CustomButton label={t("Effort.startButton")} className={classes.startButton}
                                              onClick={() => this.props.history.push('/sign-up')}/>
                            </Grid>
                        </Grid>
                        <AppFooter/>
                    </div>
                </React.Fragment> : <Redirect to={'/my-promise'}/>)
        )
    }
}

const mapStateToProps = state => ({
    lang: state.auth.lang
});

export default withTranslation()(connect(mapStateToProps, null)(withStyles(useStyles)(Effort)));
